// tslint:disable: max-line-length
import { Routes } from "@angular/router";
import { PortalLayoutComponent } from "./components/layouts/portal/portal-layout/portal-layout.component";
import { BlogComponent } from "./pages/blog/blog.component";
import { HomeComponent } from "./pages/home/home.component";
import { AboutUsComponent } from "./pages/about-us/about-us.component";
import { QuoteComponent } from "./pages/quote/quote.component";
import { BenefitsComponent } from "./pages/benefits/benefits.component";
import { InsuredComponent } from "./pages/insured/insured.component";
// import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { QuoteLayoutComponent } from "./components/layouts/quote/quote-layout/quote-layout.component";
import { LoginComponent } from "./pages/login/login.component";
import { PrivacyStatementComponent } from "./pages/privacy-statement/privacy-statement.component";
import { TermsAndConditionsComponent } from "./pages/terms-and-conditions/terms-and-conditions.component";
import { CancellationAndReturnPolicyComponent } from "./pages/cancellation-and-return-policy/cancellation-and-return-policy.component";

export const PortalRoutes: Routes = [
  {
    path: "",
    component: HomeComponent,
  },
  {
    path: "blog",
    component: BlogComponent,
  },
  {
    path: "about-us",
    component: AboutUsComponent,
  },
  {
    path: "benefits",
    component: BenefitsComponent,
  },
  {
    path: "insured",
    component: InsuredComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path:"privacy-policy",
    component: PrivacyStatementComponent
  },
  {
    path:"terms-and-conditions",
    component: TermsAndConditionsComponent
  },
  {
    path:"cancellation-and-return-policy",
    component: CancellationAndReturnPolicyComponent
  }
  // {
  //   path: "**",
  //   component: NotFoundComponent,
  // },
];

export const QuoteAppRoutes: Routes = [
  {
    path: "quote",
    component: QuoteComponent,
  },
  {
    path: "quote/:step",
    component: QuoteComponent,
  },
  {
    path: "quote/:step/:id",
    component: QuoteComponent,
  }
];

export const MainRoutes: Routes = [
  {
    path: "",
    component: PortalLayoutComponent,
    children: PortalRoutes,
  },
  {
    path: "quote-app",
    component: QuoteLayoutComponent,
    children: QuoteAppRoutes,
  },
];
